import { useFlags } from "launchdarkly-react-client-sdk";
import type { MctFlags } from "../../@types/launchdarkly";

export function useMctFlags() {
  return useFlags() as MctFlags;
}
